import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Oliver Reed",
        title: "Executive Chef",
        biography: "Oliver Reed is a highly skilled Executive Chef known for his innovative culinary techniques and dedication to exceptional dining experiences. With over a decade of experience in top restaurants, he excels in creating delectable dishes and leading a talented kitchen team. His expertise includes menu development, food presentation, and ensuring the highest quality standards. Oliver’s passion for food and commitment to excellence make him a key asset to our restaurant.",
        contacts: {
            phone: "111-222-3344",
            email: "oliver.reed@example.com",
            website: "www.oliverreedchef.com"
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#"
        },
        experience: [
            "Head Chef at Gourmet Bistro",
            "Sous Chef at The Culinary Palace",
            "Line Cook at Fine Dining Restaurant",
            "Culinary Instructor",
            "Recipe Developer"
        ],
        skills: [
            { id: 1, title: "Culinary Arts", progress: 95 },
            { id: 2, title: "Menu Development", progress: 90 },
            { id: 3, title: "Food Presentation", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Sophia Taylor",
        title: "Sous Chef",
        biography: "Sophia Taylor is a talented Sous Chef known for her precision, creativity, and exceptional leadership in the kitchen. With a strong foundation in culinary arts and years of hands-on experience, she plays a vital role in daily operations, supporting the Executive Chef in crafting memorable dishes and maintaining high culinary standards.",
        contacts: {
            phone: "222-333-4455",
            email: "sophia.taylor@example.com",
            website: "www.sophiataylorchef.com"
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#"
        },
        experience: [
            "Sous Chef at Classic Feast",
            "Pastry Chef at Artisan Bakehouse",
            "Kitchen Supervisor at Urban Eats",
            "Culinary Assistant at Chef's Table"
        ],
        skills: [
            { id: 1, title: "Culinary Management", progress: 92 },
            { id: 2, title: "Food Preparation", progress: 88 },
            { id: 3, title: "Team Coordination", progress: 90 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Benjamin Clark",
        title: "Pastry Chef",
        biography: "Benjamin Clark is a passionate Pastry Chef celebrated for his artistry in crafting exquisite desserts and baked goods. With a deep understanding of flavor balance and presentation, he consistently delivers sweet creations that are both visually stunning and delicious. His meticulous approach and innovative flair make him an essential part of our culinary team.",
        contacts: {
            phone: "333-444-5566",
            email: "benjamin.clark@example.com",
            website: "www.benjaminclarkpastry.com"
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#"
        },
        experience: [
            "Pastry Chef at Classic Feast",
            "Dessert Specialist at Sweet Palette",
            "Bakery Consultant at Artisan Delights",
            "Cake Designer at Elegant Treats"
        ],
        skills: [
            { id: 1, title: "Dessert Creation", progress: 95 },
            { id: 2, title: "Baking Techniques", progress: 90 },
            { id: 3, title: "Cake Decoration", progress: 88 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emma Wilson",
        title: "Restaurant Manager",
        biography: "Emma Wilson is a seasoned Restaurant Manager known for her strong leadership and commitment to excellence in hospitality. With years of experience in managing front-of-house operations, she ensures a smooth and welcoming dining experience for every guest. Her skills in team management, customer service, and operational efficiency are key to our restaurant's continued success.",
        contacts: {
            phone: "444-555-6677",
            email: "emma.wilson@example.com",
            website: "www.emmawilsonmanager.com"
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#"
        },
        experience: [
            "Restaurant Manager at Classic Feast",
            "Hospitality Supervisor at The Grand Table",
            "Front Desk Manager at City Bistro",
            "Customer Experience Lead at DineWell Group"
        ],
        skills: [
            { id: 1, title: "Team Leadership", progress: 93 },
            { id: 2, title: "Customer Service", progress: 95 },
            { id: 3, title: "Operations Management", progress: 90 }
        ]
    }
];

export default team;